import { UseCustomAxios } from "../../src/UseCustomAxios";

export function UseDashboard() {
  const MyAxios = UseCustomAxios();

  const getDashList = (callback) => {
    MyAxios.get(`Admin_Dashboard`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        response.data.resault.visitedPages.map((vP) => (vP.id = vP.pageID));
        callback(response.data.resault);
      }
    });
  };

  return {
    getDashList,
  };
}
